import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    gap: 8,
    color: theme.primary.p2,

    '& .MuiSvgIcon-root': {
      color: theme.primary.p2,
      width: 18,
    },
  },
  row: {
    ...dFlex(),
    position: 'relative',
  },
}));

export default useStyles;
